function ovpFetch(baseUrl, defaultOptions, callback) {
  function getHeaders(rawHeaders) {
    const headers = {};
    rawHeaders.trim().split(/[\r\n]+/).forEach((line) => {
      const parts = line.split(': ');
      const header = parts.shift();
      const value = parts.join(': ');
      headers[header.toLowerCase()] = value;
    });
    return headers;
  }

  const options = (typeof defaultOptions === 'undefined') ? {} : defaultOptions;

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    let url = baseUrl.substr(0, 4) !== 'http' ? process.env.VUE_APP_API_URL + baseUrl : baseUrl;

    if (window.auth && !options.noExtraHeaders && !options.noAuth && window.assumeParam) {
      url += `${url.includes('?') ? '&' : '?'}assumed=${window.assumeParam}`;
    }

    if (options.largeFileUpload) {
      xhr.upload.addEventListener('progress', (e) => {
        callback(e.loaded / e.total * 100);
      });
    }

    if (callback) {
      callback({ xhr });
    }

    xhr.open((options.method) ? options.method : 'GET', url);

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        const headers = getHeaders(xhr.getAllResponseHeaders());
        if (options.iLikeItRaw) {
          resolve({ data: xhr.response, headers });
        } else {
          try {
            const response = (typeof options.responseType !== 'undefined' && options.responseType !== 'json') ? xhr.response : JSON.parse(xhr.response);
            if (typeof response === 'object') {
              resolve({ data: response, headers, status: xhr.status });
            } else {
              reject(new Error('No an object'));
            }
          } catch (e) {
            reject(new Error(e));
          }
        }
      } else {
        try {
          // eslint-disable-next-line
          reject({ error: JSON.parse(xhr.response), status: xhr.status });
        } catch (e) {
          reject(new Error(xhr.statusText));
        }
      }
    };

    xhr.onerror = () => {
      // eslint-disable-next-line
      reject({ error: xhr.statusText, status: xhr.status });
    };

    let acceptHeader = 'application/vnd.streamingbolaget+json';
    let contentTypeHeader = 'application/json; charset=utf-8';

    if (options.headers) {
      Object.keys(options.headers).forEach((key) => {
        if (key === 'Accept') {
          acceptHeader = options.headers[key];
        } else if (key === 'Content-Type') {
          contentTypeHeader = options.headers[key];
        } else {
          xhr.setRequestHeader(key, options.headers[key]);
        }
      });
    }

    if (options.creds) {
      xhr.withCredentials = true;
    }

    if (!options.noExtraHeaders) {
      xhr.setRequestHeader('Accept', acceptHeader);
      if (typeof options.defaultContentType === 'undefined' || !options.defaultContentType) {
        xhr.setRequestHeader('Content-Type', contentTypeHeader);
      }
    }

    if (typeof options.responseType !== 'undefined') {
      xhr.responseType = options.responseType;
    }

    if (window.auth && !options.noExtraHeaders && !options.noAuth) {
      xhr.setRequestHeader('Authorization', `token ${window.auth}`);
    }

    if (options.body) {
      xhr.send(options.body);
    } else {
      xhr.send();
    }
  });
}

/**
 * PUT a File directly to url (e.g. a GCS signed URL) with Content-Type: file.type.
 * No Authorization header is sent — the signed URL carries its own auth.
 * @param {String} url
 * @param {File} file
 * @param {Function} onProgress - called with the upload percent (0-100)
 * @param {Function} onXhr - called with the XMLHttpRequest, so the caller can abort it
 * @return {Promise}
 */
function xhrPut(url, file, onProgress, onXhr) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.upload.addEventListener('progress', (e) => {
      onProgress(e.loaded / e.total * 100);
    });

    if (onXhr) {
      onXhr(xhr);
    }

    xhr.open('PUT', url);
    xhr.setRequestHeader('Content-Type', file.type);

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
      } else {
        reject(new Error(xhr.statusText));
      }
    };

    xhr.onerror = () => {
      reject(new Error(xhr.statusText));
    };

    xhr.send(file);
  });
}

export default { ovpFetch, xhrPut };
